<template>
  <el-dropdown
    v-if="_toolInfo.children&&!toolInfo.url"
    style="margin-right:8px;"
    @visible-change="_coverVideo(_toolInfo.id)"
    @command="commandHandle"
  >
    <span
      class="tool-link"
      :title="_toolInfo.name"
    >
      <img
        class="tool-icon"
        :src="`${_toolInfo.iconPath}`"
      >
    </span>
    <el-dropdown-menu
      :id="_toolInfo.id"
      :name="_toolInfo.id"
      slot="dropdown"
    >
      <el-dropdown-item
        class="dropdown-item"
        v-for="item in _toolInfo.children"
        :key="item.id"
        v-show="item.isShow===0"
        :command="item.id"
      >
        {{item.name}}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
  <a
    href="#"
    v-else
    style="top:4px"
    class="tool-link"
    :title="_toolInfo.name"
    @click.prevent="linkHandle(_toolInfo.id)"
  >
    <img
      class="tool-icon"
      :src="`${_toolInfo.iconPath}`"
    >
  </a>
</template>

<script>
import configuration from 'api/config'
import { mapActions } from 'vuex'
import { CoverVideo } from 'utils/mixin'
export default {
  props: {
    toolInfo: {
      type: Object
    }
  },
  data () {
    return {
      baseUrl: configuration.baseUrl
    }
  },
  computed: {
    _toolInfo () {
      this.toolInfo.children.forEach(item => {
        item.url = item.url || ''
      })
      return this.toolInfo
    }
  },
  mixins: [CoverVideo],
  methods: {
    commandHandle (command) {
      let tool
      if (command) {
        this._toolInfo.children.forEach(item => {
          if (item.id === command) {
            tool = item
          }
        })
      } else {
        tool = this._toolInfo
      }
      switch (tool.openType) {
        case 0:
          this.openMenu({
            value: tool.id,
            key: 'menuId'
          })
          break
        case 1:
          location.href = tool.url
          break
        case 2:
          window.open(tool.url)
          break
        case 4:
          this.$emit('open-tool-view', tool)
          break
      }
    },
    linkHandle () {
      this.commandHandle()
    },
    ...mapActions(['openMenu'])
  }
}
</script>
<style lang="less" scoped>
.tool-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  opacity: 0.9;
}
.tool-icon:hover {
  opacity: 1;
}
</style>
